// @flow weak

import { appConfig } from '../../config';
import {
  jsonHeaderAuth,
  refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

export const getAllNotif = async () => {
  const url = `${appConfig.BASE_API}/customernotif/readall`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const getCustNotif = async (cnumb) => {
  const url = `${appConfig.BASE_API}/customernotif/readbycn/${cnumb}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return null;
  })
  return result
};

export const insertNotif = async (req) => {
  const url = `${appConfig.BASE_API}/customernotif/insert`;
   createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
      return res.data
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};

export const deleteCustNotif = async (idnotif) => {
  const url = `${appConfig.BASE_API}/customernotif/delete/${idnotif}`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.get(url,jsonHeaderAuth())
  .then(res=>{
    // console.log('getallcustomer',res.data)
    if (res.status==200)
      return true
    else
      return false
    
    })    
   .catch (error=> {
    // console.log('error', error)
    return false;
  })
  return result
};